import React from "react";
import './Header.css';
import Logo from "../logo/Logo";
import Navigation from "../navigation/navigation";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStateValue } from '../../stateprovider';


export default function Header() {
    const [{menu}, dispatch] = useStateValue();
    return <div className={(menu === true) ? "Header__Flex__Extra__Style": "Header Header_Flex"}>   
     <div className={(menu === true)? "close" : "notDisplay"}>
     <FontAwesomeIcon icon="close" onClick={()=> {
        dispatch({
            type: "MENU",
            menu: false
        })
     }} className={(menu === true) ? "closeMenu" : "notDisplay"} />
     </div>
        <div className={(menu === true) ? "Header__SideOne notDisplay" : "Header__SideOne Header__SideOne__Flex"}>
            <Logo />
    </div>
        <div className="Header__SideTwo">
            <Navigation />
        </div>
    </div>
}